import { getBundleId, getGitHash } from "../utils/sourceMaps.js";
import { VERSION } from "../version.js";
import _objectSpread2 from "../_virtual/_@oxc-project_runtime@0.143.0/helpers/esm/objectSpread2.js";
//#region src/metas/registerInitial.ts
function registerInitialMetas(faro) {
	var _faro$config$sessionT, _faro$config$metas;
	const appName = faro.config.app.name;
	const gitHash = appName ? getGitHash(appName) : void 0;
	const initial = {
		sdk: {
			version: VERSION,
			name: "faro"
		},
		app: _objectSpread2({ bundleId: appName && getBundleId(appName) }, gitHash !== void 0 ? { gitHash } : {})
	};
	const session = (_faro$config$sessionT = faro.config.sessionTracking) === null || _faro$config$sessionT === void 0 ? void 0 : _faro$config$sessionT.session;
	if (session) faro.api.setSession(session);
	if (faro.config.app) initial.app = _objectSpread2(_objectSpread2({}, faro.config.app), initial.app);
	if (faro.config.user) initial.user = faro.config.user;
	if (faro.config.view) initial.view = faro.config.view;
	faro.metas.add(initial, ...(_faro$config$metas = faro.config.metas) !== null && _faro$config$metas !== void 0 ? _faro$config$metas : []);
}
//#endregion
export { registerInitialMetas };

//# sourceMappingURL=registerInitial.js.map